import React, { Fragment, useContext, useEffect, useState } from "react";
import axiosInstance from "../../services/api/axiosInstance";
import CardWithImage from "../../components/Cards/CardWithImage";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import { FaDownload } from "react-icons/fa";
import { FaCircleArrowUp, FaLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import CommonContext from "../../hooks/CommonContext";
import Cookie from 'js-cookie'
import Joyride, { STATUS } from 'react-joyride';
import { Card } from "react-bootstrap";
import CircularProgressBar from "./CircularProgressBar";
import { IoTimeSharp } from "react-icons/io5";
import toast from "react-hot-toast";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Image from "../../utils/images";
import { FiInfo } from "react-icons/fi";
import { formatNumber } from "ReusableFunctions/convertShowingResults";


const Home = () => {
  // Post Modal Content
  const {
    // JOY RIDE
    professionalProfileDropdown,
    professionalLearning,
    professionalCommunity,
    professionalJobs,
  } = useContext(CommonContext);

  const pageRender = useNavigate();
  const [run, setRun] = useState(false);
  const [modalApiContent, setModalApiContent] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [homePageGlow, setHomePageGlow] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [showShareModel, setshowShareModel] = useState(false);
  const [showFounderMessage, setShowFounderMessage] = useState(false)

  // JOYRIDE
  const steps = [
    {
      // title: "create page",
      target: 'body',
      content: <div className="text-center">
        <h4>Welcome to 2nd Careers!</h4>
        <p> Please take a few minutes to explore our platform</p>
      </div>,
      placement: "center"
    },
    {
      // title: "create page",
      target: `#${professionalProfileDropdown}`,
      content: 'Manage all your personal information here. Keeping your profile current ensures we can match you with the best job opportunities.',
      placement: "top"
    },
    {
      // title: "create page",
      target: `#${professionalLearning}`,
      content: 'Explore the Learning Page to discover resources that can enhance your skills and knowledge. Dive into different topics and continue your lifelong learning journey.',
      placement: "top"
    },
    {
      // title: "create page",
      target: `#${professionalCommunity}`,
      content: 'Connect with other professionals, share experiences, and seek advice by joining discussions and becoming part of our vibrant community.',
      placement: "top"
    },
    {
      // title: "create page",
      target: `#${professionalJobs}`,
      content: 'Explore all available job opportunities here. Save or apply for jobs that interest you, and also check out our personalized jobs.',
      placement: "top"
    },

  ];

  useEffect(() => {
    setRun(true);
  }, []);

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {

      // Remove a specific cookie
      Cookie.remove("isFirstVisit");

    }
  };

  //scroll to top
  const [isVisible, setIsVisible] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);

    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  window.onscroll = function () {
    handleScroll();
  };
  //

  useEffect(() => {
    setHomePageGlow(true)
    const getcommunityDatas = async () => {
      try {
        const res = await axiosInstance.get("/professional_updated_home")
        if (res.data.error_code === 0 || res.data.error_code === 200) {

          // joy ride
          if (res.data.error_code === 200) {
            Cookie.set("isFirstVisit", true);
            Cookie.set("isFirstVisitProfile", true);
            Cookie.set("isFirstVisitProfileParsing", true);
          }

          if (res.data?.data?.length) {
            setResponseData(res.data?.data[0])
          }
          setHomePageGlow(false)
        }
        else {
          setHomePageGlow(false)
        }
      }

      catch (err) {
        console.log(err)
      }
    }
    (async () => getcommunityDatas())();

  }, [])

  const getModalData = async (modalId, role) => {
    let params = {
      id: modalId,
    };

    try {
      setModalLoading(true)
      if (role === "learning") {
        const response = await axiosInstance.post("/get_detailed_description_learning", params)
        setModalLoading(false)
        if (response.data.error_code === 0) {
          setModalApiContent(response.data.data.length > 0 ? response.data.data[0].detailed_description : "");
        }
      } else {
        const response = await axiosInstance.post("/get_detailed_description_community", params)
        setModalLoading(false)
        if (response.data.error_code === 0) {
          setModalApiContent(response.data.data.length > 0 ? response.data.data[0].detailed_description : "");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  function appliedBtnCls(type) {
    switch (type) {
      case "Not Reviewed":
        return "applied_not_reviewd"

      case "Shortlisted":
        return "applied_shortlisted"

      case "Hired":
        return "applied_hired"

      case "Contacted":
        return "applied_contacted"

      case "Rejected":
        return "applied_rejected"

      default:
        break;
    }
  }

  const handleOnClick = () => {
    toast.success("Link copied");
    navigator.clipboard.writeText(responseData.community_list[0]?.join_url || '');
  };

  const handleFounderVisibility = async () => {
    try {
      setShowFounderMessage(true)
      const { data } = await axiosInstance.post("/update_home_page_video", { show_video_status: responseData?.show_video_status === "Y" ? "N" : "Y" })

      if (data?.error_code === 0) {
        const changeResponseData = { ...responseData }
        changeResponseData.show_video_status = responseData?.show_video_status === "Y" ? "N" : "Y"

        setResponseData(changeResponseData)
      }
      setShowFounderMessage(false)
    } catch (Err) {
      setShowFounderMessage(false)
      console.warn(Err?.message)
    }
  }

  return (
    <div className="professional-home-page-bg overflow-hidden">
      <div className="professional-home-page-padding">
        <div className="py-5">
          {/* section one */}
          <section className="d-flex flex-wrap align-items-stretch w-100">
            <div className="col-12 col-md-6 col-xxl-3 py-3 py-md-0 pe-md-3">
              {
                homePageGlow ?
                  <Card className="home_design_card_one border-0 h-100 placeholder-glow">
                    <Card.Body className="h-100">
                      <p className="mb-1 placeholder col-8 rounded-2 py-3"></p>
                      <h4 className="placeholder col-8 rounded-2 py-3"></h4>
                      <p className="placeholder col-10 rounded-2 py-3 mb-0"></p>
                      <div className="w-100 h-75 d-flex justify-content-end align-items-center">
                        <div className="col-8 text-end px-0">
                          <div className="home_gradient_image_placeholder placeholder py-5 rounded-2"></div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  :
                  <Card className="home_design_card_one border-0 h-100">
                    <Card.Body className="h-100">
                      <p className="mb-1">Welcome back,</p>
                      <h4 className="name_head">{responseData?.user_name}</h4>
                      <p className="greeting_msg mb-0">Glad to see you again!</p>
                      <div className="w-100 h-75 d-flex justify-content-end align-items-center">
                        <div className="col-8 text-end px-0">
                          <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}home_page_design.png`} alt="gradient_design" className="gradient_design" />
                        </div>
                      </div>
                    </Card.Body>
                    <Card.Footer className="border-0 bg-transparent d-flex">
                      <div className="col">
                        <FiInfo size={20} className="me-2 text-secondary" />
                      </div>
                      <div className="col-11">
                        <a href="https://www.oxfordlearnersdictionaries.com/definition/english/moonlight_2?q=moonlighting" target="_blank" className="w-100 text-decoration-none text-secondary text-align-middle d-inline-block moonlighting_fs">

                          <span className="col-11">2nd Careers does not support or encourage moonlighting.</span>
                        </a>
                      </div>
                    </Card.Footer>
                  </Card>
              }
            </div>

            {
              homePageGlow ?
                <div className="col-12 col-md-6 col-xxl-4 py-3 py-md-0 px-md-2 placeholder-glow">
                  <Card className="home_design_card_four border-0 h-100 ">
                    <Card.Body className="h-100 w-100 p-4">
                      <h5 className="text-secondary placeholder py-3 col-8 rounded-2"></h5>
                      <div className="col d-flex flex-wrap flex-column justify-content-between py-3">
                        {
                          [1, 2, 3]?.map((aiJobs, aiJobInd) => (
                            <div className="col-12 d-flex flex-wrap p-2 mb-3" key={aiJobInd}>
                              <div className="col-2 col-md-1 col-xxl-2 text-center">
                                <div class="placeholder rounded-circle" style={{ width: "42px", height: "42px" }}></div>
                              </div>
                              <div className="col-10 d-inline-flex justify-content-end d-xxl-none ">
                                <div className="col-8 col-lg-6 ">
                                  <button type="button" className="btn placeholder w-100 home_apply_btn"></button>
                                </div>
                              </div>

                              <div className="col-12 col-xxl-10">
                                <div className="w-100 d-flex flex-wrap">
                                  <div className="w-100 d-flex flex-wrap align-items-center pb-1">
                                    <div className="col-12 col-xxl-7 pt-3 pt-xxl-0">
                                      <h6 className="col-10 placeholder py-3 rounded-3"></h6>
                                    </div>

                                    <div className="col-5 d-none d-xxl-block">
                                      <button type="button" className="btn placeholder w-100 home_apply_btn"></button>
                                    </div>
                                  </div>

                                  <div className="col-4">
                                    <div className="home-card-options w-100">
                                      <span className="col-10 ps-1 placeholder py-3 rounded"></span>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="home-card-options w-100">
                                      <span className="col-10 ps-1 placeholder py-3 rounded"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </Card.Body>
                    <Card.Footer className="py-3 d-flex flex-wrap justify-content-center bg-transparent border-0">
                      <div className="col-10">
                        <button type="button" className="btn w-100 placeholder"> </button>
                      </div>
                    </Card.Footer>
                  </Card>
                </div>
                :
                responseData?.profile_percentage < 60 ?
                  <div className="col-12 col-md-6 col-xxl-4 py-3 py-md-0 px-md-2">
                    <Card className="home_design_card_two border-0 h-100">
                      <Card.Header className="bg-transparent border-0">
                        <h5>Profile</h5>
                      </Card.Header>
                      <Card.Body className="d-flex align-items-center justify-content-center py-4">
                        <CircularProgressBar percentage={responseData?.profile_percentage} size={150} strokeWidth={15} />
                      </Card.Body>
                      <Card.Footer className="w-100 d-flex flex-wrap border-0 home_profile_footer align-items-center py-3">
                        <div className="col-8">
                          <p className="text-light mb-0">
                            {`${responseData?.profile_percentage}%`}
                            <span className="text-light ps-2">Profile Filled</span>
                          </p>
                        </div>
                        <div className="col-4">
                          <button type="button" className="btn home_complete_profile_btn w-100" onClick={() => pageRender("/professional/profile")}>Complete Profile</button>
                        </div>
                      </Card.Footer>
                    </Card>
                  </div>
                  :
                  <div className="col-12 col-md-6 col-xxl-4 py-3 py-md-0 px-md-2">
                    <Card className="home_design_card_four border-0 h-100 ">
                      <Card.Body className="h-100 w-100 p-4">
                        <h5>AI Recommended Jobs</h5>
                        <div className="col d-flex flex-wrap flex-column py-3 h-100">
                          {
                            responseData?.ai_job_details?.length ?
                              responseData?.ai_job_details?.map((aiJobs, aiJobInd) => (
                                <div className="col-12 d-flex flex-wrap home_applied_jobs_card p-2 mb-3" key={aiJobInd}>
                                  <div className="col-2 col-md-1 col-xxl-2 text-center">
                                    <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${aiJobs?.profile_image}`} alt={`aiJob${aiJobInd}`} width={42} height={42} className="pe-none rounded-circle objectContain" />
                                  </div>
                                  <div className="col-10 d-inline-flex justify-content-end d-xxl-none ">
                                    <div className="col-8 col-lg-6 ">
                                      <button type="button" className="btn btn-brand-color w-100 home_apply_btn" onClick={() => pageRender(`/professional/recommended_jobs?job_id=${btoa(aiJobs?.id)}`)}>Apply</button>
                                    </div>
                                  </div>

                                  <div className="col-12 col-xxl-10">
                                    <div className="w-100 d-flex flex-wrap">
                                      <div className="w-100 d-flex flex-wrap align-items-center pb-1">
                                        <div className="col-12 col-xxl-7 pt-3 pt-xxl-0">
                                          <h6 className="col-12">{aiJobs?.job_title}</h6>
                                        </div>

                                        <div className="col-5 d-none d-xxl-block">
                                          <button type="button" className="btn btn-brand-color w-100 home_apply_btn" onClick={() => pageRender(`/professional/recommended_jobs?job_id=${btoa(aiJobs?.id)}`)}>Apply</button>
                                        </div>
                                      </div>

                                      <div className="flex-grow text-wrap">
                                        <div className="home-card-options ">
                                          <FaLocationDot className="col-1" />
                                          <span className="col ps-1 text-wrap">
                                            {`${aiJobs?.city},${aiJobs?.country}`}

                                          </span>
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="home-card-options">
                                          <IoTimeSharp className="col-1" />
                                          <span className="col">
                                            {aiJobs?.job_type}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                              :
                              <div className="col-12 h-100 d-flex flex-wrap justify-content-center align-items-center">
                                <div className="col-8 text-center">
                                  <img src={Image.noRecordsFound} className="w-50 h-50" alt="no data found" />
                                  <p className="mb-0">No Data Found</p>
                                </div>
                              </div>
                          }
                        </div>
                      </Card.Body>
                      <Card.Footer className="py-3 bg-transparent border-0">
                        <button type="button" className="btn exploer-btn w-100" onClick={() => pageRender("/professional/recommended_jobs")}>Explore Jobs</button>
                      </Card.Footer>
                    </Card>
                  </div>
            }

            {
              homePageGlow ?
                <div className="col-12 col-xxl-5 mt-3 mt-xxl-0 ps-xxl-3">
                  <Card className="home_design_card_five border-0 h-100">
                    <Card.Body className="h-100 w-100 p-4">
                      <div className="w-100 d-flex flex-wrap h-100">
                        <div className="col">
                          <h5 className="placeholder py-3 col-8 rounded-2"></h5>
                          <h5 className="placeholder py-3 col-5 rounded-2"></h5>
                          <p className="placeholder py-3 col-11 rounded-2"></p>
                        </div>
                        <div className="col-12 col-md-10 col-xxl-9 d-flex flex-wrap flex-column justify-content-between align-items-stretch">
                          <div className="col d-flex flex-wrap flex-column justify-content-between py-3">
                            {
                              [1, 2, 3]?.map((aiJobs, aiJobInd) => (
                                <div className="col-12 d-flex flex-wrap p-2 mb-3" key={aiJobInd}>
                                  <div className="col-2 col-md-1 col-xxl-2 text-center">
                                    <div class="placeholder rounded-circle" style={{ width: "42px", height: "42px" }}></div>
                                  </div>
                                  <div className="col-10 d-inline-flex justify-content-end d-xxl-none ">
                                    <div className="col-8 col-lg-6 ">
                                      <button type="button" className="btn placeholder w-100 home_apply_btn"></button>
                                    </div>
                                  </div>

                                  <div className="col-12 col-xxl-10">
                                    <div className="w-100 d-flex flex-wrap">
                                      <div className="w-100 d-flex flex-wrap align-items-center pb-1">
                                        <div className="col-12 col-xxl-7 pt-3 pt-xxl-0">
                                          <h6 className="col-10 placeholder py-3 rounded-3"></h6>
                                        </div>

                                        <div className="col-5 d-none d-xxl-block">
                                          <button type="button" className="btn placeholder w-100 home_apply_btn"></button>
                                        </div>
                                      </div>

                                      <div className="col-4">
                                        <div className="home-card-options w-100">
                                          <span className="col-10 ps-1 placeholder py-3 rounded"></span>
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="home-card-options w-100">
                                          <span className="col-10 ps-1 placeholder py-3 rounded"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                    <Card.Footer className="py-3 d-flex flex-wrap justify-content-center bg-transparent border-0">
                      <div className="col-10">
                        <button type="button" className="btn w-100 placeholder"> </button>
                      </div>
                    </Card.Footer>
                  </Card>
                </div>
                :
                responseData?.profile_percentage < 60 ?
                  <div className="col-12 col-xxl-5 mt-3 mt-xxl-0 ps-xxl-3 ">
                    <Card className=" border-0 home_design_card_three h-100">
                      <Card.Body className="h-100 w-100 p-4">
                        <div className="w-100 d-flex flex-wrap h-100">
                          <div className="col">
                            <h5>2nd Careers</h5>
                            <p className="mb-1">Jobs Open Now</p>
                            <h3 className="job_open_now mt-2">{formatNumber(responseData?.total_jobs)}</h3>
                          </div>
                          <div className="col-12 col-md-10 col-xxl-8 d-flex flex-wrap flex-column justify-content-between align-items-stretch py-1">
                            <div className="col-12 d-flex flex-wrap align-items-center mb-2 home_applied_jobs_card rounded">
                              <div className="col-10">
                                <div className="col-12">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M17.9981 7.16C17.9381 7.15 17.8681 7.15 17.8081 7.16C16.4281 7.11 15.3281 5.98 15.3281 4.58C15.3281 3.15 16.4781 2 17.9081 2C19.3381 2 20.4881 3.16 20.4881 4.58C20.4781 5.98 19.3781 7.11 17.9981 7.16Z" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.9675 14.4402C18.3375 14.6702 19.8475 14.4302 20.9075 13.7202C22.3175 12.7802 22.3175 11.2402 20.9075 10.3002C19.8375 9.59016 18.3075 9.35016 16.9375 9.59016" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.97047 7.16C6.03047 7.15 6.10047 7.15 6.16047 7.16C7.54047 7.11 8.64047 5.98 8.64047 4.58C8.64047 3.15 7.49047 2 6.06047 2C4.63047 2 3.48047 3.16 3.48047 4.58C3.49047 5.98 4.59047 7.11 5.97047 7.16Z" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.0014 14.4402C5.6314 14.6702 4.12141 14.4302 3.06141 13.7202C1.65141 12.7802 1.65141 11.2402 3.06141 10.3002C4.13141 9.59016 5.6614 9.35016 7.0314 9.59016" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.9981 14.6288C11.9381 14.6188 11.8681 14.6188 11.8081 14.6288C10.4281 14.5788 9.32812 13.4488 9.32812 12.0488C9.32812 10.6188 10.4781 9.46875 11.9081 9.46875C13.3381 9.46875 14.4881 10.6288 14.4881 12.0488C14.4781 13.4488 13.3781 14.5888 11.9981 14.6288Z" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.08875 17.7794C7.67875 18.7194 7.67875 20.2594 9.08875 21.1994C10.6888 22.2694 13.3087 22.2694 14.9087 21.1994C16.3187 20.2594 16.3187 18.7194 14.9087 17.7794C13.3187 16.7194 10.6888 16.7194 9.08875 17.7794Z" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </div>
                                <div className="col-12 pt-3">
                                  <h6 className="text-break">Professionals in Our Network</h6>
                                </div>
                              </div>
                              <div className="col-2 text-center">
                                <h6>{formatNumber(responseData?.total_professionals)}</h6>
                              </div>
                            </div>

                            <div className="col-12 d-flex flex-wrap align-items-center mb-2 home_applied_jobs_card rounded">
                              <div className="col-10">
                                <div className="col-12">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M9.15859 10.87C9.05859 10.86 8.93859 10.86 8.82859 10.87C6.44859 10.79 4.55859 8.84 4.55859 6.44C4.55859 3.99 6.53859 2 8.99859 2C11.4486 2 13.4386 3.99 13.4386 6.44C13.4286 8.84 11.5386 10.79 9.15859 10.87Z" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.4112 4C18.3512 4 19.9112 5.57 19.9112 7.5C19.9112 9.39 18.4113 10.93 16.5413 11C16.4613 10.99 16.3713 10.99 16.2812 11" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.15875 14.56C1.73875 16.18 1.73875 18.82 4.15875 20.43C6.90875 22.27 11.4188 22.27 14.1688 20.43C16.5888 18.81 16.5888 16.17 14.1688 14.56C11.4288 12.73 6.91875 12.73 4.15875 14.56Z" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14" stroke="#F58B0E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </div>
                                <div className="col-12 pt-3">
                                  <h6 className="text-break">Trusted Employers Onboard</h6>
                                </div>
                              </div>
                              <div className="col-2 text-center">
                                <h6>{formatNumber(responseData?.total_employers)}</h6>
                              </div>
                            </div>


                            <div className="col-12 d-flex flex-wrap align-items-center mb-2 home_applied_jobs_card rounded">
                              <div className="col-10">
                                <div className="col-12">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M8.0008 22H16.0008C20.0208 22 20.7408 20.39 20.9508 18.43L21.7008 10.43C21.9708 7.99 21.2708 6 17.0008 6H7.0008C2.7308 6 2.0308 7.99 2.3008 10.43L3.0508 18.43C3.2608 20.39 3.9808 22 8.0008 22Z" stroke="#F58B0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6" stroke="#F58B0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14 13V14C14 14.01 14 14.01 14 14.02C14 15.11 13.99 16 12 16C10.02 16 10 15.12 10 14.03V13C10 12 10 12 11 12H13C14 12 14 12 14 13Z" stroke="#F58B0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M21.65 11C19.34 12.68 16.7 13.68 14 14.02" stroke="#F58B0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.62109 11.2695C4.87109 12.8095 7.41109 13.7395 10.0011 14.0295" stroke="#F58B0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </div>
                                <div className="col-12 pt-3">
                                  <h6 className="text-break">Partner Programs to Upskill</h6>
                                </div>
                              </div>
                              <div className="col-2 text-center">
                                <h6>{formatNumber(responseData?.total_learning_posts)}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                  :
                  <div className="col-12 col-xxl-5 mt-3 mt-xxl-0 ps-xxl-3">
                    <Card className="home_design_card_five border h-100">
                      <Card.Body className="h-100 w-100 p-4">
                        <div className="w-100 d-flex flex-wrap h-100">
                          <div className="col">
                            <h5>Job Status</h5>
                            <h3 className="ps-2">{responseData?.applied_jobs?.length ? responseData?.applied_jobs[0]?.total_applied_jobs : 0}</h3>
                            <p className="mb-1 ps-2">Applied jobs</p>
                          </div>
                          <div className="col-12 col-md-10 col-lg-8 col-xxl-9 d-flex flex-wrap flex-column align-items-stretch">
                            {
                              responseData?.applied_jobs?.length ?
                                responseData?.applied_jobs?.map((appliedJobs, appliedJobInd) => (
                                  appliedJobInd < 3 ?
                                    <div className="col-12 d-flex flex-wrap p-2 mb-3 home_applied_jobs_card rounded" key={appliedJobInd}>
                                      <div className="col-2 col-md-1 col-xxl-2 text-center">
                                        <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${appliedJobs?.profile_image}`} alt={`aiJob${appliedJobInd}`} width={42} height={42} className="pe-none rounded-circle objectContain" />
                                      </div>
                                      <div className="col-10 d-inline-flex justify-content-end d-xxl-none ">
                                        <div className="col-8 col-lg-4">
                                          <button type="button" className={`btn w-100 ${appliedBtnCls(appliedJobs?.application_status)} pe-none`}>
                                            {appliedJobs?.application_status === "Contacted" ? "Invited" : appliedJobs?.application_status}
                                          </button>
                                        </div>
                                      </div>

                                      <div className="col-12 col-xxl-10">
                                        <div className="w-100 d-flex flex-wrap ">
                                          <div className="w-100 d-flex flex-wrap align-items-center pb-2">
                                            <div className="col-12 col-xxl-7 pt-3 pt-xxl-0">
                                              <h6 className="col-12 mb-0">{appliedJobs?.job_title}</h6>
                                            </div>

                                            <div className="col-5 d-none d-xxl-block">
                                              <button type="button" className={`btn w-100 ${appliedBtnCls(appliedJobs?.application_status)} pe-none`}>
                                                {appliedJobs?.application_status === "Contacted" ? "Invited" : appliedJobs?.application_status}
                                              </button>
                                            </div>
                                          </div>

                                          <div className=" text-wrap">
                                            <div className="home-card-options">
                                              <FaLocationDot className="col-1" />
                                              <span className="col ps-2">
                                                {`${appliedJobs?.location !== ", " ? appliedJobs?.location : 'Not Mentioned'}`}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="col">
                                            <div className="home-card-options">
                                              <IoTimeSharp className="col-1" />
                                              <span className="col">
                                                {appliedJobs?.job_type}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    :
                                    null
                                ))
                                :
                                <div className="col-12 h-100 d-flex flex-wrap justify-content-center align-items-center">
                                  <div className="col-8 text-center">
                                    <img src={Image.noRecordsFound} className="w-50 h-50" alt="no data found" />
                                    <p className="mb-0">No Data Found</p>
                                  </div>
                                </div>
                            }
                          </div>
                        </div>
                      </Card.Body>
                      <Card.Footer className="py-3 bg-transparent border-0">
                        <button type="button" className="btn exploer-btn w-100" onClick={() => pageRender("/professional/applied_jobs")}>View Applied Jobs</button>
                      </Card.Footer>
                    </Card>
                  </div>
            }
          </section>

          {/* section two */}
          <section className="mt-3">
            {
              homePageGlow ?
                <Card className="profeesional_home_community w-100 border-0 py-3 placeholder-glow">
                  <Card.Body>
                    <div className="d-flex flex-wrap h-100 align-items-center">
                      <div className="col-12 col-md-3 col-xxl-2 text-center">
                        <div className="col p-3">
                          <div className="placeholder community_placeholder_img"></div>
                        </div>
                      </div>
                      <div className="col-md-9 col-xxl-10 pt-3 pt-md-0">
                        <div className="d-flex flex-wrap">
                          <div className="col-10">
                            <h3 className="col-6 placeholder py-2 rounded-2"></h3>
                          </div>

                          <div className="col-12">
                            <Card className="p-2 border-0 rounded-4">
                              <Card.Body>
                                <div className="d-flex flex-wrap align-items-end">
                                  <div className="col-12 col-xxl-8">
                                    <h6 className="col-5 placeholder py-3 rounded-2"></h6>
                                    <p className="col-12 placeholder py-5 rounded-2 mb-0"></p>
                                  </div>
                                  <div className="col-12 col-xxl-4 d-flex flex-wrap">
                                    <div className="col-6 p-1">
                                      <button type="button" className="btn btn-light border-1 border-secondary w-100 placeholder"></button>
                                    </div>
                                    <div className="col-6 p-1">
                                      <button type="button" className="btn btn-light border-1 border-secondary w-100 placeholder"></button>
                                    </div>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
                :
                <Card className="profeesional_home_community w-100 border-0 py-3">
                  <Card.Body>
                    <div className="d-flex flex-wrap h-100 align-items-center">
                      <div className="col-12 col-md-3 col-xxl-2 text-center">
                        <div className="col">
                          <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${responseData?.community_list?.length ? responseData?.community_list[0]?.image : ''}`} alt="gradient_design" className="gradient_design" />
                        </div>
                      </div>
                      <div className="col-md-9 col-xxl-10 pt-3 pt-md-0">
                        <div className="d-flex flex-wrap">
                          <div className="col-10">
                            <h5 className="">Join a Thriving Community of Professionals!</h5>
                          </div>

                          <div className="col-12 mt-3">
                            <Card className="p-2 border-0 rounded-4">
                              <Card.Body>
                                <div className="d-flex flex-wrap align-items-end">
                                  <div className="col-12 col-xxl-8">
                                    <p className="community_heading mb-1">{responseData?.community_list?.length ? responseData?.community_list[0]?.title : ''}</p>
                                    <p className="card-text">{responseData?.community_list?.length ? responseData?.community_list[0]?.short_description : ''}</p>
                                  </div>
                                  <div className="col-12 col-xxl-4 d-flex flex-wrap">
                                    <div className="col-6 p-1">
                                      <button type="button" className="btn btn-light border-1 border-secondary w-100" onClick={() => setshowShareModel(true)}>Share</button>
                                    </div>
                                    <div className="col-6 p-1">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          if (responseData?.community_list?.length) {
                                            const url = responseData.community_list[0]?.join_url;
                                            if (url) window.open(url, "_blank");
                                          }
                                        }}
                                        disabled={!responseData?.community_list?.length}
                                        className="btn btn-brand-color w-100"
                                      >
                                        Join Community
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
            }
          </section>

          {/* section three */}
          <section className="py-3 py-lg-5 row mt-5 mt-lg-0 align-items-stretch">
            {homePageGlow ?
              null
              :
              <div className="col-12">
                <h5 className="mb-1 mb-2 ps-3">
                  <span>Explore Learning Opportunities with Our Partners</span>
                  <span><FaCircleArrowUp className="professional-homepage-explore-icon cursorPointer" onClick={() => pageRender('/professional/learning')} /></span>
                </h5>
              </div>
            }

            {homePageGlow ?
              <div className="col-12 d-flex flex-wrap">
                {[1, 2, 3]?.map((learningPlaceholder, learningPlaceholderInd) => (
                  <div className="col-12 col-md-6 col-xxl-4 p-2" key={learningPlaceholderInd}>
                    <div className="homepage-card-bg-color p-4 h-100">
                      <div className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow" aria-hidden="true">
                        <div className="col-12 p-3">
                          <span className="placeholder col-12 py-4 rounded-top"></span>
                          <span className="placeholder col-12 py-4"></span>
                          <span className="placeholder col-12 py-4"></span>
                          <span className="placeholder col-12 py-4 rounded-bottom"></span>
                        </div>

                        <div className="ps-4">
                          <span className="placeholder col-2 py-4 rounded-5 "></span>
                          <span className="placeholder col-3 ms-2 py-3 rounded-3"></span>
                        </div>
                        <div className="card-body p-0">
                          <div className="p-3 py-4">
                            <h5 className="card-title ">
                              <span className="placeholder col-6 py-3 rounded-3"></span>
                            </h5>
                            <span className="placeholder col-3 py-2 rounded"></span>
                            <p className="card-text">
                              <span className="placeholder col-12 py-2 rounded "></span>
                              <span className="placeholder col-12 py-2 rounded"></span>
                              <span className="placeholder col-12 py-2 rounded"></span>
                              <span className="placeholder col-8 py-2 rounded"></span>
                            </p>
                          </div>
                        </div>
                        <div className="card-footer d-flex justify-content-between">
                          <button className="btn btn-outline-secondary placeholder col-5"></button>
                          <button className="btn btn-outline-secondary placeholder col-5"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              :
              responseData?.learning_posts?.length ?
                <div className="d-flex flex-wrap w-100">
                  {responseData?.learning_posts?.map((learningData, learningInd) => (
                    <div className="col-12 col-md-6 col-xxl-4 p-2" key={learningInd}>
                      <div className="homepage-card-bg-color p-4 h-100">
                        <CardWithImage
                          cardImage={learningData?.image}
                          cardTitle={learningData?.title}
                          companyName={learningData?.company_name}
                          companyImage={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${learningData?.profile_image}`}
                          postedDate={learningData?.created_at}
                          id={learningData?.id}
                          cardTitleStyle="learningTitle"
                          imageClassName="rounded-3 img-fluid learning-img-height w-100"
                          cardText={learningData?.detailed_description ? `${learningData?.detailed_description.slice(0, 85)}....` : ''}
                          cardKey={0}
                          cardParaTestId="professionalTestId"
                          cardButtonTestId="cardButton"
                          role="learning"
                          secondButton_Name="Learn&nbsp;more"
                          icon={<FaDownload className="me-2" />}
                          firstCardColor="outline-secondary"
                          secondCardColor="brand-color"
                          modalContent={modalApiContent}
                          leftLearnUrl={learningData?.attached_file}
                          rightLearnUrl={learningData?.url}
                          getModalData={getModalData}
                          modalId={learningData?.id}
                          modalLoading={modalLoading}
                          dataFrom="professionalHome"
                          viewedCount={learningData?.view_count}
                        />
                      </div>
                    </div>
                  ))
                  }
                </div>
                :
                <div className="row align-items-center homepage-nojob-card">
                  <p className="text-center">No Data Found</p>
                </div>
            }
          </section>

          <section className="w-100 placeholder-glow">
            {
              homePageGlow ?
                <button type="button" className="btn bg-secondary-subtle text-start w-100 p-3 rounded-2 py-4">
                </button>
                :
                <button type="button" className={`btn message_from_founder_btn fs-20 text-start w-100 p-3 rounded-2 position-relative ${showFounderMessage ? "pe-none" : ""}`} onClick={handleFounderVisibility}>
                  Message From Our Founders

                  <span className="message_from_founder_arrow">
                    {
                      showFounderMessage ?
                        <div class="spinner-border founder_message_spinner" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        :
                        responseData?.show_video_status === "Y" ?
                          <IoIosArrowDown className="fs-4" />
                          :
                          <IoIosArrowUp className="fs-4" />
                    }
                  </span>
                </button>
            }

          </section>

          {/* section four */}
          {
            homePageGlow ?
              <section className="mt-4">
                <Card className="founder_card border-0 py-0 px-4 placeholder-glow">
                  <Card.Body>
                    <div className="d-flex flex-wrap align-items-center py-2 py-lg-5">
                      <div className="col-12 col-lg-7 px-3">
                        <div className="col-10">
                          <h2 className="col-8 mb-3 placeholder rounded-3 py-4"></h2>
                        </div>
                        <h6 className="col-10 professional-homepage-contentOne placeholder rounded-top-3 mb-0 w-100 py-5"></h6>
                        <h6 className="col-10 professional-homepage-contentOne placeholder mb-0 w-100 py-5"> </h6>
                        <h6 className="col-10 professional-homepage-contentOne placeholder mb-3 rounded-bottom-3 w-100 py-5"></h6>
                        <button type="button" className="btn placeholder col-8"></button>
                      </div>

                      <div className="col-12 col-lg-5 mt-4 mt-lg-0 professional-homepage-video overflow-hidden position-relative p-0 text-center">
                        <div className="placeholder w-100 video_placehlder_height" ></div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </section>
              :
              responseData?.show_video_status === "Y" ?
                <section className="mt-4">
                  <Card className="founder_card border-0 py-0 px-4">
                    <Card.Body>
                      <div className="d-flex flex-wrap align-items-center py-2 py-lg-5">
                        <div className="col-12 col-lg-7">
                          <div className="col-10">
                            <h5 className="home-page-para-color mb-4">Message from our founders</h5>
                          </div>
                          <h6 className="col-11 card-text mb-3">Welcome to 2nd Careers, the platform that helps professionals join a community of people over 50 and serves as a marketplace for learning and employment.</h6>
                          <h6 className="col-11 card-text mb-3">Please take a few moments to watch the video message from the founders and explore the links below! </h6>
                          <h6 className="col-11 card-text mb-3">Our best wishes to you for the journey you are about to embark on with 2nd Careers.</h6>
                          <button type="button" className="btn btn-brand-color" onClick={() => {
                            scrollToTop()
                            pageRender("/professional/profile")
                          }}>
                            Let's Complete Your Profile
                          </button>
                        </div>

                        <div className="col-12 col-lg-5 mt-4 mt-lg-0 professional-homepage-video overflow-hidden position-relative p-0 text-center">
                          <video id="myVideo" poster={`${process.env.REACT_APP_SECOND_CAREERS_CDN}thumbnails.png`} src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${responseData?.video_url}`} type="video/mp4" allowFullScreen controls frameBorder={0} > </video>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </section>
                :
                null
          }
        </div>
      </div >

      {/* section Footer */}
      <section section className="professional-home-footer" >
        <div className="professional-home-page-padding">
          <div className="col-12 py-3 row">
            <div className="col-6">
              <h6 className="mb-0">© 2024 2nd Careers. All rights reserved.</h6>
            </div>
            <div className="col-6">
              <h6 className="text-end mb-0"><span className="cursorPointer" onClick={() => window.open("https://www.2ndcareers.com/terms-conditions", "_blank")}>Terms&nbsp;and&nbsp;conditions
              </span> | <span className="cursorPointer" onClick={() => window.open("https://www.2ndcareers.com/privacypolicy", "_blank")}>Privacy policy</span></h6>
            </div>
          </div>
        </div>
      </section >

      {/* bottom right scroll top  */}
      <div div className="professional-home-scroll-to-top-icon" id="scroll-to-top-icon" onClick={scrollToTop} title="Scroll to top" style={{ display: isVisible ? 'block' : 'none' }}>
        <BsFillArrowUpCircleFill className='fs-1 brand-color' />
      </div >

      {/* Share Modal */}
      <Modal
        show={showShareModel}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setshowShareModel(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title id="contained-modal-title-vcenter">
            Share
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2 position-relative">
            <input
              className="form-control  mx-auto mt-0 linkFieldSize"
              id="message-text"
              value={responseData.community_list ? responseData.community_list[0]?.join_url : ''}
              readOnly
            />
            <button
              id="communityCardCopyButton"
              type="button"
              className="btn btn-brand-color button-position"
              onClick={handleOnClick}
            >
              Copy
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {
        !homePageGlow && Cookie.get("isFirstVisit") ?
          <Joyride
            callback={handleJoyrideCallback}
            styles={{
              options: {
                width: '500px',
                borderRadius: "60px"
              },
              buttonNext: {
                background: '#e38212',
                outline: 'none'
              },
              buttonSkip: {
                textDecoration: 'underline'
              },
              buttonBack: {
                backgroundColor: '#fff',
                border: " 0px",
                borderRadius: "4px",
                color: "#000",
                cursor: "pointer",
                fontSize: "16px",
                lineHeight: "1",
                padding: "8px",
                appearance: "none",
                outline: "1px solid grey",
              }
            }}
            scrollOffset={300}
            continuous
            disableOverlayClose={true}
            hideCloseButton
            showSkipButton
            showProgress
            steps={steps}
            run={run}
          />
          :
          null
      }
    </div >
  );
};

export default Home;